import { render, staticRenderFns } from "./NewPatient.vue?vue&type=template&id=435af028&scoped=true&"
import script from "./NewPatient.vue?vue&type=script&lang=js&"
export * from "./NewPatient.vue?vue&type=script&lang=js&"
import style0 from "./NewPatient.vue?vue&type=style&index=0&id=435af028&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435af028",
  null
  
)

export default component.exports